import { render, staticRenderFns } from "./workflow_info_panel.vue?vue&type=template&id=41ebdfe4&"
import script from "./workflow_info_panel.vue?vue&type=script&lang=js&"
export * from "./workflow_info_panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports